import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Popover from '@material-ui/core/Popover';
import { CURSOR} from '../../../../styles/fonts/MCFontConstants';
import {
    ContentContainer,
    CalendarPanelHeader,
} from 'src/pages/home/component/calendarPanel/Panel.Styled';

export const OrderPanelHeader = styled(CalendarPanelHeader)`
    ${media.mobileDevice`
        z-index:2000;
        margin-top: ${({ bannerHeight }) =>
            bannerHeight ? bannerHeight : 'unset'}
    `}
`;

export const OrderContentContainer = styled(ContentContainer)`
    padding: 10px 0 5px 0;
    ${media.mobileDevice`
        padding: 0 0.95rem 0px 0.95rem;   
    `}
    @media only screen 
        and (max-width: 1000px) 
        and (max-height: 500px) 
        and (orientation: landscape) {
            padding: 30px 0 5px 0;
        }
`;

export const FilterPopover = styled(Popover)`
    & .MuiPaper-root {
        top: 130px !important;
    }
    ${media.mobileDevice`
        & .MuiPaper-root{
            top: 0 !important;
            left:0 !important;
        }
        & .MuiPopover-paper{
            max-width: 100vw;
            max-height: 100vh;
            transition: all 100ms ease-in-out !important;
        }
    `}
`;
export const Icon = styled.div`
    background: url(${(props) => props.deskPath});
    width: 100%;
    height: 100%;
    cursor: ${CURSOR};
    ${media.mobileDevice`
    background: url(${(props) => props.mobilePath});
    opacity: ${(props) => (props.isSearch ? '0.4' : '1')}
    `}
`;
